import {isNil, isNotNil} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';

import {getSafely, parseDate} from 'shared/web';

type VehiclePriceChanges = Pick<SourcingVehicleResponseBody, 'priceChanges' | 'priceChangesDates'>;
type PriceChange = {price: number; date: number};

export function getPriceChanges(vehicle?: VehiclePriceChanges | null) {
  return (
    vehicle?.priceChanges
      ?.map((price, index) => {
        const date = parseDate(getSafely(vehicle.priceChangesDates, index))?.getTime();

        return isNil(date) ? undefined : {price, date};
      })
      .filter((priceChange): priceChange is PriceChange => isNotNil(priceChange))
      .sort((a, b) => a.date - b.date) ?? []
  );
}

export function getFirstScrapedPrice<TFallback extends number | null | undefined>(
  vehicle: VehiclePriceChanges | null | undefined,
  fallbackPrice: TFallback
): number | TFallback {
  return getSafely(getPriceChanges(vehicle), 0)?.price ?? fallbackPrice;
}
